import Api from '@/api/vacancy.js';
import axios from 'axios';
import { parseResponse } from '@/_helpers/utils.js';

export default {
  namespaced: true,

  state() {
    return {
      item: {},
      loaded: false,
      error: false,
      token: null,
      response: null,
      isLandingLoaded: false,
      candidate: null,
      checkbox: {
        check: false,
        agree_video: true
      }
    };
  },

  actions: {
    async load(context, id) {
      context.commit('set_loaded', true);
      context.commit('set_error', false);

      return await axios
        .get(`/1.0/public-vacancies/${id}`)
        .then(r => {
          context.commit('set_token', id);
          context.commit('set_item', r.data.data[0]);
          context.commit('set_loaded', false);

          // save processName from Meta if it is
          if (r.data.data[0].meta.active_process !== undefined) {
            context.commit('process/setName', r.data.data[0].meta.active_process, { root: true });
          }

          context.commit('SET_IS_LANDING_LOADED', true);
        })
        .catch(e => {
          context.commit('set_error', e);
          context.commit('set_loaded', false);
          return Promise.reject(e);
        });
    },

    validate(context, data) {
      return axios.post(`/1.0/public-vacancies/${data.vacancyToken}/responses/validate`, {
        candidate: data.candidate
      });
    },

    save(context, data) {
      context.commit('set_loaded', true);
      return axios
        .post(`/1.0/public-vacancies/${data.vacancyToken}/responses`, {
          responses: [
            {
              candidate: data.candidate,
              social_source: data.source
            }
          ],
          captcha_token: data.captcha_token
        })
        .then(r => {
          context.commit('set_loaded', false);
          localStorage.setItem('agree_' + r.data.data[0].interview.token, true);

          if (data.resumeFile) {
            Api.publicVacancySaveCandidateResume({
              vacancyToken: data.vacancyToken,
              responseToken: r.data.data[0].token,
              resumeFile: data.resumeFile
            })
              .then(data => context.commit('saveUserSuccess', data))
              .catch(err => {
                context.commit('saveUserWithResumeFileFailure', err);
                context.dispatch('global/setError', err, { root: true });
              });
          } else {
            context.commit('saveUserSuccess', data);
          }
          return Promise.resolve(r);
        })
        .catch(err => {
          context.commit('set_error', err);
          context.commit('set_loaded', false);

          return Promise.reject(err);
        });
    },

    uploadResume(context, model) {
      let data = null;
      data = new FormData();

      if (model.resumeFile) {
        data.append('resume', model.resumeFile);
      } else if (!model.hasResumeName) {
        data.append('resume', null);
      }

      data.append('resume_url', model.resumeUrl || '');

      return axios
        .post(
          `/1.0/public-vacancies/${model.vacancyToken}/responses/${model.responseToken}/resume`,
          data
        )
        .then(response => parseResponse(response).data[0])
        .catch(err => Promise.reject(err));
    }
  },

  mutations: {
    SET_CANDIDATE(state, val) {
      state.candidate = val;
    },

    SET_CHECK(state, val) {
      state.checkbox.check = val;
    },

    SET_AGREE_VIDEO(state, val) {
      state.checkbox.agree_video = val;
    },

    set_item(state, val) {
      state.item = val;
    },

    set_loaded(state, val) {
      state.loaded = val;
    },

    set_token(state, val) {
      state.token = val;
    },

    set_error(state, val) {
      state.error = val;
    },

    saveUserSuccess(state, data) {
      state.response = data;
    },

    saveUserWithResumeFileFailure(state, err) {
      state.error = err;
    },

    SET_IS_LANDING_LOADED: (state, payload) => {
      state.isLandingLoaded = payload;
    }
  },

  getters: {
    item: state => state.item,
    loaded: state => state.loaded,
    error: state => state.error,
    token: state => state.token,
    process: state => (state.item.meta ? state.item.meta.active_process : null),
    vacancyCountry: state => (state.item && state.item.country ? state.item.country.code : null)
  }
};
